import {createFileRoute, Outlet} from '@tanstack/react-router'
import {PhaseBar} from '@/features/sprints/PhaseBar'

function SprintsLayout() {
	return (
		<div className='flex h-full min-h-0 flex-col bg-background font-sans text-foreground'>
			<PhaseBar />
			<div className='min-h-0 flex-1 overflow-y-auto'>
				<Outlet />
			</div>
		</div>
	)
}

export const Route = createFileRoute('/sprints')({
	component: SprintsLayout,
})
